module.exports = __webpack_public_path__ + "static/media/lisa.ff0b961e.jpg";